require('../shared/application').setup();

import vogue from 'vogue';
import React, { Component } from 'react';


export class ShareCalendar extends Component {
  render() {
    return (
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <h1>Share your calendar with Clara Labs</h1>
                  <p>Your recruiting team is getting scheduling support from Clara Labs. In order for us to invite you to interviews that are convenient, we'll need to use information from your calendar.</p>
                  <p>Let Clara Labs see your availability if you're using either G Suite or Microsoft Office 365.</p>
              </div>
          </div>
          <div className="row">
            <div className="col-12">
                <a class="btn btn-primary btn-block" role="button" href="https://api.claralabs.com/google_accounts/actions/update_or_create?next=https%3A//claralabs.com/successfully_shared/">
                    Sign in with Google
                </a>
            </div>
          </div>
          <div className="row">
                <div className="col-12">
                    <a class="btn btn-primary btn-block" role="button" href="https://api.claralabs.com/microsoft_accounts/actions/update_or_create?next=https%3A//claralabs.com/successfully_shared/">
                        Sign in with Microsoft
                    </a>
                </div>
          </div>
      </div>
    );
  }
}

vogue.shim({
  ShareCalendar: ShareCalendar,
});
